import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import OpeningImportPanel from './openingBalances/OpeningImportPanel';
import { OpeningBalanceService } from '../../services/openingBalance.service';
import { CoaImportResult } from '../../interfaces/openingBalance.interface';
import { parseCoaCsv } from '../../utils/csvImport';

interface Props {
    open: boolean;
    onClose: () => void;
    /** Called after a successful commit so the chart can reload. */
    onImported: () => void;
}

/** Chart-of-accounts CSV import: preview first (per-row create / exists / error), then import. */
const CoaImportDialog: React.FC<Props> = ({ open, onClose, onImported }) => (
    <Dialog data-help-page="accounting.coa.import.page" open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle>Import chart of accounts (CSV)</DialogTitle>
        <DialogContent dividers>
            <OpeningImportPanel<{ code: string; name: string; type: string; parentCode: string; kind: string }, CoaImportResult>
                templateKey="coa"
                description={<>Columns: Code (10 digits), Name, Type (ASSET, LIABILITY, EQUITY, REVENUE, EXPENSE), Parent Code
                    (optional - derived from the code prefix when blank) and Posting/Group. Accounts that already exist are
                    skipped; if any row has an error nothing is created.</>}
                parse={parseCoaCsv}
                run={(rows, dryRun) => OpeningBalanceService.importAccounts(rows, dryRun)}
                renderSummary={r => <span>{r.createCount} to create, {r.existingCount} already exist.</span>}
                postLabel="Import accounts"
                confirmText="Create the new accounts shown in the preview?"
                onCommitted={onImported}
            />
        </DialogContent>
        <DialogActions><Button data-help="accounting.coa.import.close" onClick={onClose}>Close</Button></DialogActions>
    </Dialog>
);

export default CoaImportDialog;
